module.exports = {
    baseUrl: 'https://service.komunestudio.com'
}